import Vue from 'vue';
import './registerServiceWorker';
import router from './router';

import { VueDiContainer } from 'vue-di-container';

// Plugins
import i18n from '@/plugins/i18n';
import najizMui from '@moj/najiz-mui';
import vuetify from '@/plugins/vuetify';
import najizToaster, { IToasterAPI } from '@moj/najiz-toastify';
import initializeApplication from '@/plugins/application-initialization';
// Components
import App from './views/App/app';
// styles
import '../public/styles/main.scss';
import HttpService from '@/services/httpService';

import LoaderService from './services/loader';

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.use(VueDiContainer);
Vue.use(najizMui);
Vue.use(najizToaster);

declare module 'vue/types/vue' {
  interface Vue {
    $appInsights: any;
    $nToaster: IToasterAPI;
  }
}

declare global {
  interface Window {
    $config: any;
    $disableNewRequestsPeriod: any;
    showLoader(): void;
    hideLoader(): void;
  }
}

initializeApplication().then(() => {
  new Vue({
    i18n,
    router,
    vuetify,
    diProvide: [
      HttpService,
      LoaderService,
    ],
    render: (h) => h(App),
  }).$mount('#app');
});
